import { Account, CompanyKycDetailsResponse } from '@/types';
import { apiSlice } from './apiSlice';

export interface KycPayload {
  panNumber: string;
  dob: string;
  occupation: string;
  monthlyIncome: string;
  addressLine1: string;
  city: string;
  state: string;
  country: string;
  pincode: string;

  documents: {
    type: string;
    url: string;
  }[];
}

export enum KycStatus {
  Submitted = 'Submitted',
  Approved = 'Approved',
  Rejected = 'Rejected',
}

export interface KycRequest {
  id: number;
  status: KycStatus;
  submittedAt: string | null;
  reviewedAt: string | null;
  verifier: string;
  account: Account;
}

export interface PaginatedResponse<T> {
  data: T[];
  skip: number;
  take: number;
  count: number;
}
export const kycApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    submitKyc: builder.mutation<void, { id: string; payload: KycPayload }>({
      query: ({ id, payload }) => ({
        url: `/kyc/${id}`,
        method: 'POST',
        body: payload,
      }),
    }),
    getTrusteeKycAccounts: builder.query<
      PaginatedResponse<KycRequest>,
      { skip?: number; take?: number; search?: string; status?: KycStatus }
    >({
      query: ({ skip = 0, take = 10, search, status }) => ({
        url: '/kyc',
        params: {
          skip,
          take,
          ...(search ? { search } : {}),
          status,
        },
      }),
      providesTags: ['Kyc'],
    }),
    updateKycStatus: builder.mutation<
      void,
      {
        id: number;
        action: KycStatus;
        rejectionReason?: string;
      }
    >({
      query: ({ id, ...body }) => ({
        url: `/kyc/${id}/verify`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Kyc', 'Accounts'],
    }),
    getCompanyKycDetailsId: builder.query<CompanyKycDetailsResponse, number>({
      query: (companyId) => ({
        url: `/kyc/company/${companyId}`,
        method: 'GET',
      }),
      providesTags: ['Kyc'],
    }),
  }),
});

export const {
  useSubmitKycMutation,
  useGetTrusteeKycAccountsQuery,
  useUpdateKycStatusMutation,
  useGetCompanyKycDetailsIdQuery,
} = kycApi;
